module.exports = __webpack_public_path__ + "static/media/eng-popup-step2.d7020279.png";